// step47 (2026-10-22, Fabrique layout; based on step42): Kassandra newsletter popup. Home + collection only (Liquid). 8s or exit intent (desktop).
// Closed/subscribed -> hidden 30 days (localStorage kcNlPopup). Never over a visible Klaviyo form. Focus trap, Esc, aria-modal.
(() => {
  const root = document.getElementById('kc-nl');
  if (!root) return;
  if (/(^|\/)(products|cart|checkout|checkouts|account)(\/|$)/.test(location.pathname)) return; // step48 guard
  const KEY = 'kcNlPopup', DAYS = { closed: 2, subscribed: 365 }, DELAY = 5000; // step48: Label Rose timing
  const dialog = root.querySelector('.kc-nl__dialog');
  const form = root.querySelector('form');
  const params = new URLSearchParams(location.search);
  const preview = params.get('kc_nl');
  const posted = !!root.querySelector('[data-kc-nl-posted]') || preview === 'success';
  const hasError = !!root.querySelector('[data-kc-nl-error]');
  let lastFocus = null, timer = null, open = false;

  const store = {
    get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } },
    set(state) { try { localStorage.setItem(KEY, JSON.stringify({ state, until: Date.now() + (DAYS[state] || 2) * 864e5 })); } catch (e) {} }
  };
  const suppressed = () => { const s = store.get(); return !!(s && s.until > Date.now()); };
  const klaviyoVisible = () => [...document.querySelectorAll('.klaviyo-form, [class*="kl-private"]')].some((el) => {
    if (root.contains(el)) return false;
    const r = el.getBoundingClientRect(), c = getComputedStyle(el);
    return r.width > 40 && r.height > 40 && c.display !== 'none' && c.visibility !== 'hidden' && +c.opacity > 0.05 && r.bottom > 0 && r.top < innerHeight;
  });
  const focusables = () => [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])')].filter((el) => el.offsetParent !== null || el === document.activeElement);

  function show(force) {
    if (open) return;
    if (!force && (suppressed() || klaviyoVisible() || document.querySelector('dialog[open], .k-atp-mobile-drawer.is-open'))) return;
    open = true; clearTimeout(timer);
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-visible')));
    const first = posted ? root.querySelector('[data-kc-nl-copy]') : (hasError ? root.querySelector('#kc-nl-email') : root.querySelector('#kc-nl-email'));
    setTimeout(() => (first || dialog).focus({ preventScroll: true }), 60);
    document.removeEventListener('mouseout', onExit);
  }
  function hide() {
    if (!open) return;
    open = false;
    if (!posted) store.set('closed');
    root.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    setTimeout(() => { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) show(); }

  root.addEventListener('click', (e) => { if (e.target.closest('[data-kc-nl-close]')) hide(); });
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
    if (e.key !== 'Tab') return;
    const f = focusables(); if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  if (form) form.addEventListener('submit', (e) => {
    const email = form.querySelector('#kc-nl-email');
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
      e.preventDefault(); email.setAttribute('aria-invalid', 'true'); email.focus();
      let err = form.querySelector('[data-kc-nl-error]');
      if (!err) { err = document.createElement('p'); err.className = 'kc-nl__error'; err.setAttribute('role', 'alert'); err.dataset.kcNlError = ''; email.before(err); }
      err.textContent = 'Inserisci un indirizzo email valido.';
      return;
    }
    // 'subscribed' is stored only after Shopify confirms (posted_successfully), so a blocked/failed post is not suppressed
  });
  const copyBtn = root.querySelector('[data-kc-nl-copy]');
  if (copyBtn) copyBtn.addEventListener('click', async () => {
    const code = root.querySelector('[data-kc-nl-code]').textContent.trim();
    const msg = root.querySelector('[data-kc-nl-copied]');
    try { await navigator.clipboard.writeText(code); }
    catch (e) { const r = document.createRange(); r.selectNodeContents(root.querySelector('[data-kc-nl-code]')); const s = getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); } catch (_) {} }
    copyBtn.textContent = 'COPIATO!'; if (msg) msg.textContent = 'Codice copiato negli appunti.';
    setTimeout(() => { copyBtn.textContent = 'COPIA CODICE'; }, 2500);
  });

  if (posted) {
    store.set('subscribed');
    root.querySelector('[data-kc-nl-view="form"]').hidden = true;
    root.querySelector('[data-kc-nl-view="success"]').hidden = false;
    show(true);
    return;
  }
  if (hasError || preview === '1') { show(true); return; }
  if (suppressed()) return;
  timer = setTimeout(() => show(), DELAY);
  if (!matchMedia('(pointer: coarse)').matches) document.addEventListener('mouseout', onExit); // desktop only (no touch-primary pointer)
})();
